

















































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import API from '@/utils/api'
import moment from '@/plugins/moment'
import { BackendGame } from '@/models/BackendGame'
import Countdown from '@/components/Countdown.vue'
import PlayerStat from '@/components/PlayerStat.vue'
import { Lineup } from '@/models/Lineup'
import { namespace } from 'vuex-class'
import { Roster } from '@/models/Roster'
import { Prediction } from '@/models/Prediction'
import { Player } from '@/models/Player'
import { Team } from '@/models/Team'
import { Salary } from '@/models/Salary'
import { ShortStat } from '@/models/ShortStat'
import { Status } from '@/models/Status'
import { Position } from '@/models/Position'
import { BackendGameFull } from '@/models/BackendGameFull'
const AppStore = namespace('AppStore')

@Component({
  props: {
    lineups: {
      type: Array as () => Lineup[],
      required: true,
    },
    statuses: {
      type: Array as () => Status[],
      required: true,
    },
    positions: {
      type: Array as () => Position[],
      required: true,
    },
    roster: {
      type: Array as () => Roster[],
      required: true,
    },
    rgPredictions: {
      type: Array as () => Prediction[],
      required: true,
    },
    ourPredictions: {
      type: Array as () => Prediction[],
      required: true,
    },
    awPredictions: {
      type: Array as () => Prediction[],
      required: true,
    },
    facts: {
      type: Array as () => Prediction[],
      required: true,
    },
    team: {
      type: Object as () => Team,
      required: true,
    },
    salaries: {
      type: Array as () => Salary[],
      required: true,
    },
    stats: {
      type: Array as () => ShortStat[],
      required: true,
    },
    room: {
      type: String,
      required: true,
    },
    lineupType: {
      type: String,
      required: true,
    },
    game: {
      type: Object as () => BackendGameFull,
      required: true,
    },
  },
  components: { Countdown, PlayerStat },
})
export default class Lineups extends Vue {
  moment: any = moment
  textForNewNote: string = ''
  @AppStore.State dark!: boolean
  playerIdForStats: number | null = null
  playerStatsShowed: boolean = false
  holdoutSplitPlayer: Player | null = null
  hoveredLineupId: number = -1
  splitColors: string[] = [
    'amber',
    'light-green',
    'cyan',
    'red',
    'blue',
    'purple',
  ]
  tabs: string[] = ['off', 'def']
  headers: any[] = [
    { name: '', value: '', type: 'remove-player', isDef: true },
    { name: '', value: '', type: 'split-player' },
    { name: '', value: 'order', type: 'text-warning', isDef: true },
    { name: 'Name', value: 'player.name', type: 'text-name', isDef: true },
    { name: 'Pos', value: 'position.name', type: 'text' },
    {
      name: 'RG',
      value: this.getRgPrediction,
      type: 'func',
      sum: this.getRgSum,
    },
    {
      name: 'AW',
      value: this.getAwPrediction,
      type: 'func',
      sum: this.getAwSum,
    },
    {
      name: 'OUR',
      value: this.getOurPrediction,
      type: 'func',
      sum: this.getOurSum,
    },
    { name: 'Fact', value: this.getFact, type: 'func' },
    { name: 'FPM', value: 'fantasy_points_modifier', type: 'number' },
    { name: 'SPM', value: 'split_modifier', type: 'number' },
    { name: 'Merge', value: 'is_merge', type: 'checkbox' },
    {
      name: 'Status',
      value: 'status',
      type: 'chip-group',
      items: this.$props.statuses,
    },
    { name: 'Salary', value: this.getSalary, type: 'func' },
    { name: 'Eff', value: this.getOurEff, type: 'func' },
    { name: 'S', value: this.getSnaps, type: 'func' },
    { name: 'N', type: 'note' },
  ]
  getClassesForCell(lineup: Lineup, header: any) {
    let hasOurPred = typeof this.getOurPrediction(lineup) === 'number'
    let hasRgPred = typeof this.getRgPrediction(lineup) === 'number'
    let hasAwPred = typeof this.getAwPrediction(lineup) === 'number'
    let classes: string[] = [header.name]
    if (header.name === 'OUR') {
      if (
        (!hasOurPred && (hasRgPred || hasAwPred)) ||
        (!hasRgPred && (hasOurPred || hasAwPred)) ||
        (!hasAwPred && (hasRgPred || hasOurPred))
      ) {
        classes.push('no-predict')
      }
    } else if (header.name === 'S') {
      let snaps = this._getSnaps(lineup)
      if (snaps[0] === 0) {
        classes.push('warning')
      }
    }
    return classes
  }
  get isDef() {
    return this.$props.lineupType === 'DEF'
  }
  get cols() {
    return this.isDef ? 6 : 12
  }
  get filteredPositions() {
    return this.$props.positions.filter((p: Position) =>
      this.isDef ? p.name === 'DEF' : p.name !== 'DEF'
    )
  }
  get filteredLineups() {
    return this.$props.lineups.filter((l: Lineup) =>
      this.isDef ? l.position.name == 'DEF' : l.position.name !== 'DEF'
    )
  }
  get filteredHeaders() {
    let headers = this.headers
    if (this.isDef) {
      return headers.filter((h: any) => h.isDef)
    }
    if (this.$props.facts.length === 0) {
      headers = headers.filter((h) => h.name !== 'Fact')
    }
    if (this.$props.stats.length === 0) {
      headers = headers.filter((h) => h.name !== 'S')
    }
    return headers
  }
  get splits() {
    let splits: any = []
    let lineups: Lineup[] = this.$props.lineups
    lineups.forEach((el: Lineup) => {
      if (el.split_player) {
        let starterSplit: Lineup | undefined = lineups.find(
          (ell: Lineup) =>
            ell.player &&
            el.split_player &&
            ell.player.id === el.split_player.id
        )
        if (starterSplit) {
          splits.push([el.id, starterSplit.id])
        }
      }
    })
    return splits
  }
  isDeviationValue(
    sitePrediction: number | undefined,
    ourPrediction: number | undefined
  ) {
    return (
      sitePrediction &&
      ourPrediction &&
      ((ourPrediction * 1.25 < sitePrediction &&
        sitePrediction - ourPrediction > 2) ||
        (sitePrediction * 1.25 < ourPrediction &&
          ourPrediction - sitePrediction > 2))
    )
  }
  addNote(lineup: Lineup) {
    if (!lineup.player) {
      return
    }
    return API.createNote(
      lineup.player.id,
      this.$props.game.main_game.week_id,
      this.textForNewNote
    ).then((r: any) => {
      lineup.notes.push(r.data)
    })
  }
  getSum(forWhat: string) {
    forWhat = forWhat.charAt(0).toUpperCase() + forWhat.slice(1).toLowerCase()
    let funcName = `get${forWhat}Prediction`
    let res = 0
    this.$props.lineups.forEach((l: Lineup) => {
      let pred = (this as any)[funcName](l)
      if (pred) res += pred
    })
    return res.toFixed(1)
  }
  filterStatusItems(items: any[], lineup: Lineup) {
    let res = items
    if (lineup.id !== this.hoveredLineupId) {
      res = res.filter((r: any) => r.id === lineup.status.id)
    }
    return res
  }
  getRgSum() {
    return this.getSum('rg')
  }
  getAwSum() {
    return this.getSum('aw')
  }
  getOurSum() {
    return this.getSum('our')
  }
  showPlayerStats(playerId: number | null) {
    if (playerId) {
      this.playerIdForStats = playerId
      this.playerStatsShowed = true
    }
  }
  getRgPrediction(lineup: Lineup) {
    let pred: Prediction | undefined = this.$props.rgPredictions.find(
      (p: Prediction) =>
        p.room_name === this.$props.room &&
        lineup.player &&
        p.player_id === lineup.player.id
    )
    if (pred) {
      return pred.prediction
    }
  }
  getSalary(lineup: Lineup) {
    let salary = this.$props.salaries.find(
      (s: Salary) =>
        lineup.player &&
        s.player_id === lineup.player.id &&
        s.room == this.$props.room
    )
    if (salary) {
      return salary.salary
    }
  }
  _getSnaps(lineup: Lineup) {
    let stat = this.$props.stats.find(
      (s: ShortStat) => s.player_id === lineup.player?.id
    )
    let res = [-1, -1]
    if (stat) {
      res = [stat.off_snaps_pct, stat.st_snaps_pct]
    }
    return res
  }
  getSnaps(lineup: Lineup) {
    let snaps = this._getSnaps(lineup)
    if (snaps[0] == -1) {
      snaps = []
    }
    return snaps.join(', ')
  }
  getOurEff(lineup: Lineup) {
    let salary = this.getSalary(lineup)
    let ourPrediction = this.getOurPrediction(lineup)
    if (salary && ourPrediction) {
      return ((ourPrediction * 1000) / salary).toFixed(2)
    }
  }
  getLineupWarnings(lineup: Lineup) {
    let warnings: string[] = []
    let player: Player | undefined = lineup.player
    if (player) {
      if (lineup.position.name != 'DEF') {
        if (!player.rotogrinders_id) {
          warnings.push('No rg_id')
        }
        if (!player.awesemo_id) {
          warnings.push('No aw_id')
        }
      }
      if (!['DST'].includes(lineup.position.name)) {
        let roster: Roster | undefined = this.getRoster(player.id)
        if (!roster) {
          warnings.push('Not in roster')
        }
        if (roster) {
          if (roster.team.id !== this.$props.team.id) {
            warnings.push(
              `In roster, but team is ${roster.team.alias} (need ${this.$props.team.alias})`
            )
          }
          if (!roster.is_active) {
            warnings.push('In roster, but is_active=False')
          }
        }
      }
    }
    return warnings
  }
  getRoster(playerId: number) {
    return this.$props.roster.find((r: Roster) => r.player.id === playerId)
  }
  getOurPrediction(lineup: Lineup) {
    let pred: Prediction | undefined = this.$props.ourPredictions.find(
      (p: Prediction) =>
        p.room_name === this.$props.room &&
        lineup.player &&
        p.player_id === lineup.player.id
    )
    if (pred) {
      return pred.prediction
    }
  }
  getFact(lineup: Lineup) {
    let pred: Prediction | undefined = this.$props.facts.find(
      (p: Prediction) =>
        p.room_name === this.$props.room &&
        lineup.player &&
        p.player_id === lineup.player.id
    )
    if (pred) {
      return pred.prediction
    }
  }
  getAwPrediction(lineup: Lineup) {
    let pred: Prediction | undefined = this.$props.awPredictions.find(
      (p: Prediction) =>
        p.room_name === this.$props.room &&
        lineup.player &&
        p.player_id === lineup.player.id
    )
    if (pred) {
      return pred.prediction
    }
  }
  isSplitButton(lineup: Lineup) {
    if (lineup.position.name === 'DST') return false
    let res: boolean = false
    if (lineup.split_player || !this.holdoutSplitPlayer) {
      res = true
    }
    if (this.holdoutSplitPlayer) {
      let l = this.$props.lineups.find(
        (l: Lineup) => l.player?.id === this.holdoutSplitPlayer?.id
      )
      res = l.position.name === lineup.position.name
    }
    return res
  }
  splitPlayer(lineup: Lineup) {
    if (lineup.split_player) {
      lineup.split_player = undefined
    } else if (this.holdoutSplitPlayer) {
      lineup.split_player = this.holdoutSplitPlayer
      this.holdoutSplitPlayer = null
    } else {
      this.holdoutSplitPlayer = lineup.player || null
    }
  }
  getSplitColor(l: Lineup) {
    let index: number = this.splits.indexOf(
      this.splits.find((el: any) => el.includes(l.id))
    )
    return this.splitColors[index]
  }
  getDeepValue(obj: object, index: string) {
    let segments = index.split('.')
    let value: object | number = obj
    segments.forEach((segment: string) => {
      // @ts-expect-error
      value = value ? value[segment] : undefined
    })
    if (index === 'order' && this.isDef && typeof value === 'number') {
      value =
        (value as number) -
        Math.max(
          ...this.$props.lineups
            .filter((l: Lineup) => l.position.name !== 'DEF')
            .map((l: Lineup) => l.order)
        )
    }
    return value || ''
  }
  filterRoster(positionId: number) {
    let playerIds: number[] = []
    this.$props.lineups.forEach((lineup: Lineup) => {
      if (lineup.player) playerIds.push(lineup.player.id)
    })
    return this.$props.roster.filter(
      (r: Roster) =>
        r.position.id === positionId && !playerIds.includes(r.player.id)
    )
  }
  isPlayerInjured(player: Player | null) {
    if (player) {
      let roster: Roster = this.$props.roster.find(
        (r: Roster) => r.player.id === player.id
      )
      if (roster) {
        return roster.is_injured
      }
    }
  }
  removePlayer(lineup: Lineup) {
    if (lineup.position.name === 'DST') return
    lineup.player = undefined
    this.$emit('lineupChangeg')
  }
  addPlayer(roster: Roster) {
    let lineup: Lineup | undefined = this.getEmptyLineup(roster.position.id)
    if (!lineup) return
    lineup.player = roster.player
    return
  }
  getEmptyLineup(positionId: number) {
    let lineups: Lineup[] = this.$props.lineups.filter(
      (lineup: Lineup) => !lineup.player && lineup.position.id === positionId
    )
    if (lineups.length) {
      return lineups[0]
    }
    return undefined
  }
  isLastPosInLineups(lineup: Lineup) {
    let lastOrderForPos = Math.max(
      ...this.$props.lineups
        .filter((l: Lineup) => l.position.id == lineup.position.id)
        .map((l: Lineup) => l.order)
    )
    return (
      lastOrderForPos === lineup.order ||
      (lineup.position.name === 'DEF' && lineup.order === 27)
    )
  }
}
